import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Timestamp } from '@atoms';

const PointContainer = styled.div`
  &.question {
    margin-top: 60px;
  }
`;

const DiscussionPointText = styled.p`
  @media print {
    orphans: 4;
    widows: 4;
  }
`;
const Person = styled.span`
  font-weight: bold;
`;

class DiscussionPoint extends PureComponent {
  static defaultProps = {
    timestamp: null,
  };

  render() {
    const DiscussionPointHeader = (
      <span>
        {this.props.timestamp !== null && (
          <span>
            <Timestamp timestamp={this.props.timestamp} />
            <br />
          </span>
        )}
        <Person>{this.props.person}:&nbsp;</Person>
      </span>
    );
    const pointClassName = this.props.type ? this.props.type.toLowerCase() : '';

    return (
      <div>
        <PointContainer
          id={`discussion-point-${this.props.id}`}
          className={pointClassName}
        >
          {this.props.text.split('\n').map((paragraph, index) => (
            <DiscussionPointText key={index}>
              {index === 0 && DiscussionPointHeader}
              {paragraph}
            </DiscussionPointText>
          ))}
        </PointContainer>
      </div>
    );
  }
}

DiscussionPoint.propTypes = {
  id: PropTypes.number.isRequired,
  person: PropTypes.string.isRequired,
  timestamp: PropTypes.number,
  text: PropTypes.string.isRequired,
  type: PropTypes.string,
};

export default DiscussionPoint;



// WEBPACK FOOTER //
// ./components/molecules/DiscussionPoint.js